import script from "./CreateAttributeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAttributeForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateAttributeForm.vue?vue&type=style&index=0&id=2679208d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2679208d"]])

export default __exports__